'use client';

import Link from 'next/link';
import { motion } from 'motion/react';
import { Home, AlertCircle } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Background Glows */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-indigo-600/10 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-purple-600/10 rounded-full blur-[120px] animate-pulse delay-700" />

      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center text-center z-10"
      >
        <div className="relative mb-8">
          <motion.img 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            src="https://iptvgo-web.vercel.app/app-icon.png" 
            alt="IPTV GO" 
            className="w-24 h-24 drop-shadow-[0_0_25px_rgba(79,70,229,0.3)]"
          />
        </div>

        <motion.div
           initial={{ opacity: 0 }}
           animate={{ opacity: 1 }}
           transition={{ delay: 0.4 }}
        >
          <h1 className="text-8xl font-black text-white mb-4 tracking-tighter">404</h1>
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="h-px w-8 bg-gray-800" />
            <span className="text-indigo-400 font-bold uppercase tracking-widest text-xs">Page Not Found</span>
            <div className="h-px w-8 bg-gray-800" />
          </div>
          
          <p className="text-gray-400 max-w-md mx-auto mb-10 leading-relaxed">
            The channel you're looking for seems to be offline or the link has expired. 
            Don't worry, you can always head back to the main lobby.
          </p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link 
            href="/" 
            className="flex items-center gap-3 px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-2xl font-bold transition-all shadow-xl shadow-indigo-600/20 group"
          >
            <Home size={20} className="group-hover:-translate-y-0.5 transition-transform" />
            Back to Home
          </Link>
        </motion.div>
      </motion.div>

      {/* Subtle bottom footer */}
      <div className="absolute bottom-8 text-gray-600 text-[10px] uppercase font-bold tracking-[0.2em]">
        IPTV GO Unified Ecosystem
      </div>
    </div>
  );
}
